export default __webpack_public_path__ + "static/favicon-32x32-69deafeffc4a4d5c7302f1eda7ca6b2c.png";